import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  DateRangePicker,
  Input,
  Pagination,
  Table,
  Toggle,
} from "rsuite";
import {
  EmployeeAttritionDataVM,
  EmployeeDataVM,
} from "../../Models/ViewModels";
import * as EmployeeData from "../../Services/EmployeeDB";
import { GetUserLoginID, SetIDRole } from "../../Services/UserSessionManager";
import { PageHeader } from "../../SharedComponents/PageHeader";
import { EmployeeInformation } from "../EmployeeInformation/EmployeeInfo";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { Whisper } from "rsuite";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import {
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";

const { Column, HeaderCell, Cell } = Table;

export const AttritionDetails = () => {
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [isLoading, setLoading] = useState(true);

  const [limit, setLimit] = React.useState(15);
  const [page, setPage] = React.useState(1);
  const [tableInfo, setTableInfo] = useState(
    new Array<EmployeeAttritionDataVM>()
  );
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<EmployeeAttritionDataVM>()
  );
  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<EmployeeAttritionDataVM>()
  );
  const [toggled, setToggled] = useState(false);
  const [date, setDate] = React.useState<Date>();
  const [popup, setpopUp] = useState(false);
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [searching, setSearching] = useState(false);
  const [value, setValue] = useState(true);

  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");
  const handleClose = () => setpopUp(false);
  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });
  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  useEffect(() => {
    GetAttritionEmployee();
  }, []);

  const GetAttritionEmployee = () => {
    EmployeeData.GetResignedEmployeeList(loginid).then((resp) => {
      setTableInfo(resp.data);
      setFilteredEmployeesList(resp.data);
      setCachedEmployeesList(resp.data);
      setDate(resp.data[0].Date_of_Exit.substring(0, 7));
      setLoading(false);
    });
  };
  const filterData = () => {
    setPage(1);
    let search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;
    let search2value = (document.getElementById("Search2") as HTMLInputElement)
      .value;

    setFilteredEmployeesList(
      tableInfo.filter(
        (e) =>
          includesSearchValue(e, searchby, search1value) &&
          includesSearchValue(e, searchby2, search2value)
      )
    );
  };

  const includesSearchValue = (
    e: EmployeeAttritionDataVM,
    searchBy: string,
    searchText: string
  ) => {
    switch (searchBy) {
      case "ID":
        return e.EmployeeId.toLowerCase().includes(searchText.toLowerCase());

      case "Name":
        return e.EmployeeName.toLowerCase().includes(searchText.toLowerCase());

      case "EmploymentType":
        return e.EmploymentType.toLowerCase().includes(
          searchText.toLowerCase()
        );
      case "Gender":
        return e.Gender.toLowerCase().includes(searchText.toLowerCase());

      case "Designation":
        return e.Designation.toLowerCase().includes(searchText.toLowerCase());

      case "OfficeLocation":
        return e.OfficeLocation.toLowerCase().includes(
          searchText.toLowerCase()
        );

      case "Department":
        return e.Department.toLowerCase().includes(searchText.toLowerCase());

      case "PrimaryReportingOfficer":
        return e.PrimaryReportingOfficer.toLowerCase().includes(
          searchText.toLowerCase()
        );

      case "SecondaryReportingOfficer":
        return e.SecondaryReportingOfficer.toLowerCase().includes(
          searchText.toLowerCase()
        );
      case "IndirectReportees":
        return (
          e.Reporting3.toLowerCase().includes(searchText.toLowerCase()) ||
          e.Reporting4.toLowerCase().includes(searchText.toLowerCase()) ||
          e.Reporting5.toLowerCase().includes(searchText.toLowerCase()) ||
          e.Reporting6.toLowerCase().includes(searchText.toLowerCase()) ||
          e.Reporting7.toLowerCase().includes(searchText.toLowerCase()) ||
          e.PrimaryReportingOfficer.toLowerCase().includes(
            searchText.toLowerCase()
          ) ||
          e.SecondaryReportingOfficer.toLowerCase().includes(
            searchText.toLowerCase()
          )
        );
      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };

  const handleSet = (value: any) => {
    var resultfilteredData = cachedEmployeesList.filter((a) => {
      var date = a.Date_of_Exit.substring(0, 7);
      return date == value;
    });
    setFilteredEmployeesList(resultfilteredData);
  };

  const handelDetailsPopUp = (rowdata: any) => {
    setId(rowdata.EmployeeID);
    setTitle(rowdata.EmployeeName);
    setpopUp(true);
  };

  const handledate = (value: any) => {
    setDate(value);
    var startdd = value[0].getUTCDate();
    if (startdd < 10) startdd = "0" + startdd;
    var startmm = value[0].getUTCMonth() + 1;
    if (startmm < 10) startmm = "0" + startmm;
    const startdate = startdd + "/" + startmm + "/" + value[0].getFullYear();
    var enddd = value[1].getUTCDate();
    if (enddd < 10) enddd = "" + startdd;
    var endmm = value[1].getUTCMonth() + 1;
    if (endmm < 10) endmm = "0" + endmm;
    const enddate = enddd + "/" + endmm + "/" + value[1].getFullYear();
    var res = tableInfo.filter((e) => {
      var date = e.Date_of_Exit;

      return (
        date >= startdate.split("/").reverse().join("-") &&
        date <= enddate.split("/").reverse().join("-")
      );
    });
    setFilteredEmployeesList(res);
    setTableInfo(res);
  };

  const SearchBy = (value: any) => {
    setSearchBy(value);
  };
  const SearchBy2 = (value: any) => {
    setSearchBy2(value);
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-2">
          <PageHeader title="Attrition Report" backPage="">
            <></>
          </PageHeader>
        </div>

        {!toggled ? (
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-3">
                <DateRangePicker
                  //onSelect={date}

                  placeholder="Select Date Range"
                  onOk={(value: [Date, Date]) => handledate(value)}
                  format="yyy-MM-dd"
                />
              </div>
              <div className="col-md-4">
                <InputGroup className="mb-3">
                  <DropdownButton
                    variant="outline-secondary"
                    title={searchby}
                    id="input-group-dropdown-1"
                  >
                    <Dropdown.Item href="#" onClick={() => SearchBy("ID")}>
                      ID
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy("Name")}>
                      Name
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("EmploymentType")}
                    >
                      Employment Type
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy("Gender")}>
                      Gender
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Designation")}
                    >
                      Designation
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("OfficeLocation")}
                    >
                      Office Location
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("PrimaryReportingOfficer")}
                    >
                      Primary Reporting Officer
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("SecondaryReportingOfficer")}
                    >
                      Secondary Reporting Officer
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("IndirectReportees")}
                    >
                      Indirect Reportees
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Dropdown")}
                    >
                      Default
                    </Dropdown.Item>
                  </DropdownButton>
                  <Form.Control
                    aria-label="Text input with dropdown button"
                    id="Search1"
                    onChange={(event) => filterData()}
                    placeholder="Search..."
                  />
                </InputGroup>
              </div>
              <div className="col-md-4">
                <InputGroup className="mb-3">
                  <DropdownButton
                    variant="outline-secondary"
                    title={searchby2}
                    id="input-group-dropdown-1"
                  >
                    <Dropdown.Item href="#" onClick={() => SearchBy2("ID")}>
                      ID
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy2("Name")}>
                      Name
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("EmploymentType")}
                    >
                      Employment Type
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy2("Gender")}>
                      Gender
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Designation")}
                    >
                      Designation
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("OfficeLocation")}
                    >
                      Office Location
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("PrimaryReportingOfficer")}
                    >
                      Primary Reporting Officer
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("SecondaryReportingOfficer")}
                    >
                      Secondary Reporting Officer
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("IndirectReportees")}
                    >
                      Indirect Reportees
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Dropdown")}
                    >
                      Default
                    </Dropdown.Item>
                  </DropdownButton>
                  <Form.Control
                    aria-label="Text input with dropdown button"
                    id="Search2"
                    onChange={(event) => filterData()}
                    placeholder="Search..."
                  />
                </InputGroup>
              </div>

              <div className="col-md-1">
                {searching == true ? (
                  <button
                    id="color"
                    onClick={() => handleDownloadAsExcel(filteredEmployeesList)}
                  >
                    <BootstrapIcon
                      bootStrapIconName={"file-earmark-arrow-down-fill"}
                      size={35}
                      cssClasses={"pe-2"}
                    />{" "}
                  </button>
                ) : (
                  <button
                    id="color"
                    onClick={() => handleDownloadAsExcel(filteredEmployeesList)}
                  >
                    <BootstrapIcon
                      bootStrapIconName={"file-earmark-arrow-down-fill"}
                      size={35}
                      cssClasses={"pe-2"}
                    />
                    {""}
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-3 "></div>
        )}

        <hr />
      </div>
      {!toggled ? (
        <div>
          <Table
            id="table"
            data={tableDataFeed}
            loading={isLoading}
            autoHeight={true}
            headerHeight={30}
            rowHeight={30}
            bordered={true}
            cellBordered={true}
            className="border border-dark mt-2"
            onRowClick={(rowData: object) => {
              handelDetailsPopUp(rowData);
            }}
          >
            <Column flexGrow={40} align="center" fixed>
              <CustomTableHeaderCell placement={"ID"}>
                {/* <CustomComponent placement={"ID"} /> */}ID
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="EmployeeId" />
            </Column>
            <Column width={150} fixed>
              <CustomTableHeaderCell placement={"Name"}>
                Name
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="EmployeeName" />
            </Column>
            <Column resizable width={100}>
              <CustomTableHeaderCell placement={"Employment Type"}>
                Employment Type
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="EmploymentType" />
            </Column>
            <Column width={120} resizable>
              <CustomTableHeaderCell placement={"Gender"}>
                Gender
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Gender" />
            </Column>
            <Column width={100} resizable>
              <CustomTableHeaderCell placement={"Designation"}>
                Designation
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Designation" />
            </Column>
            <Column width={150}>
              <CustomTableHeaderCell placement={"OfficeLocation"}>
                OfficeLocation
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="OfficeLocation" />
            </Column>
            <Column width={140}>
              <CustomTableHeaderCell placement={"Department"}>
                Department
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Department" />
            </Column>
            <Column width={200}>
              <CustomTableHeaderCell placement={"Reporting Mngr 1"}>
                Reporting Mngr 1
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="PrimaryReportingOfficer" />
            </Column>
            <Column width={150}>
              <CustomTableHeaderCell placement={"Reporting Mngr 2"}>
                Reporting Mngr 2
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="SecondaryReportingOfficer" />
            </Column>
            <Column width={150}>
              <CustomTableHeaderCell placement={"Reporting Mngr 3"}>
                Reporting Mngr 3
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Reporting3" />
            </Column>
            <Column width={150}>
              <CustomTableHeaderCell placement={"Reporting Mngr 4"}>
                Reporting Mngr 4
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Reporting4" />
            </Column>{" "}
            <Column width={180}>
              <CustomTableHeaderCell placement={"Reporting Mngr 5"}>
                Reporting Mngr 5
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Reporting5" />
            </Column>{" "}
            <Column width={150}>
              <CustomTableHeaderCell placement={"Reporting Mngr 6"}>
                Reporting Mngr 6
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Reporting6" />
            </Column>
            <Column width={120} resizable>
              <CustomTableHeaderCell placement={"Date of Exit"}>
                Date of Exit
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Date_of_Exit" />
            </Column>
            <Column width={120} resizable>
              <CustomTableHeaderCell placement={"Reason"}>
                Reason
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Reason" />
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredEmployeesList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="row">
        <div className="col-md-10"></div>
      </div>
    </div>
  );
};
